/*
 * Validates a Gift Card Amount.
 */

module.exports = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attrs, $ctrl) {
            $ctrl.$validators.giftCardAmount = (modelValue, viewValue) => {
                const maxAmount = scope.$eval(attrs.wowGiftCardAmountValidation);
                if ($ctrl.$isEmpty(modelValue) || !maxAmount && maxAmount !== 0) {
                    return true;
                }

                return viewValue <= maxAmount;
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/wallet/giftcard/gift-card-amount-validation.directive.js